module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl1-100.b4b9de58.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl1-100.png
// module id = 3308
// module chunks = 11